// Material helpers
import { createTheme } from "@material-ui/core";

import palette from "../../../theme/palette";
import typography from "../../../theme/typography";
import overrides from "../../../theme/overrides";

export const singleRegistryTheme = createTheme({
  palette,
  overrides,
  breakpoints: {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0,
  },
  typography: {
    ...typography,
    h1: {
      ...typography.h1,
      fontFamily: "'Ubuntu', Arial, sans-serif",
      color: "#1E293B",
    },
    h2: {
      ...typography.h2,
      fontFamily: "'Ubuntu', Arial, sans-serif",
      color: "#1E293B",
    },
    h3: {
      ...typography.h3,
      fontFamily: "'Ubuntu', Arial, sans-serif",
      color: "#1E293B",
    },
    h4: {
      ...typography.h4,
      fontFamily: "'Ubuntu', Arial, sans-serif",
      color: "#1E293B",
    },
     h5: {
      ...typography.h5,
      fontFamily: "'Ubuntu', Arial, sans-serif",
      color: "#1E293B",
    },
    body1: {
      fontFamily: "'Ubuntu', Arial, sans-serif",
      fontSize: "14px",
      letterSpacing: "-0.05px",
      lineHeight: "21px",
      color:"#525866"
    },
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
  props: {
    // Name of the component ⚛️
    MuiButtonBase: {
      // The default props to change
      disableRipple: true, // No more ripple, on the whole application 💣!
      classes: {},
    },
    MuiInputLabel: {
      shrink: true,
      classes: {},
    },
    MuiFormLabel: {
      classes: {},
    },
    MuiInputBase: {
      classes: {
        error: "error",
      },
    },
    MuiFormControl: {
      classes: {},
    },
    MuiTextField: {
      classes: {},
    },
    MuiButton: {
      classes: {},
    },
    MuiFormHelperText: {
      classes: {},
    },
  },
});

export default singleRegistryTheme;
